import { ClinicaParceira } from '../../../interfaces/clinica-parceira';

/** Clínica parceira escolhida no lugar de um agendamento: mesmo formato que o resto do fluxo lê de selectedAgenda. */
export interface SelecaoParceira {
  parceira: true;
  id: null;
  cdAgendaParceira: number;
  doctorId: number;
  doctorName: string;
  classification: 'EXAM';
  isParceiro: true;
  nmClinicaParceira: string;
  specialtyName: string;
  cdConvenio: null;
  cdCategoria: null;
}

export function selecaoParceira(c: ClinicaParceira): SelecaoParceira {
  const nome = c.nmClinica || c.dsAgenda;
  return {
    parceira: true,
    id: null,
    cdAgendaParceira: Number(c.cdAgenda),
    doctorId: Number(c.cdMedico),
    doctorName: nome,
    classification: 'EXAM',
    isParceiro: true,
    nmClinicaParceira: nome,
    specialtyName: 'Exames',
    cdConvenio: null,
    cdCategoria: null,
  };
}

export function ehSelecaoParceira(agenda: any): agenda is SelecaoParceira {
  return agenda?.parceira === true && Number(agenda.cdAgendaParceira) > 0;
}

export function filtrarParceiras(lista: ClinicaParceira[], termo: string): ClinicaParceira[] {
  const t = termo.trim().toLowerCase();
  if (!t) return lista;
  return lista.filter(c => (c.nmClinica ?? '').toLowerCase().includes(t) || (c.dsAgenda ?? '').toLowerCase().includes(t));
}
